import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const exposeViewWidgets = makeDynamicConfigWidgets([
  {
    name: 'exposeViewWidget',
    cols: 12,
  },
]);

export const exposeBookWidgets = makeDynamicConfigWidgets([
  {
    name: 'visitBookingWidget',
    cols: 12,
  },
]);
